import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { useSmartCatalogueQuery } from '../api/smart.api';

/**
 * The way into the Smart Report Builder from the Overview.
 *
 * A guided builder, not a chat and not AI: it offers only what this account may report on, and its
 * quick reports are the ones the server already validated for this reader. A quick report travels
 * to the builder in the router's own state, never in the address bar.
 */
export function SmartReportsHero() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const catalogue = useSmartCatalogueQuery();
  const quick = catalogue.data?.quickReports.slice(0, 4) ?? [];
  if (catalogue.data && catalogue.data.areas.length === 0) return null;

  return (
    <Card className="from-brand-50 border-brand-100 bg-gradient-to-br to-white p-4 sm:p-5">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 space-y-1">
          <h2 className="text-ink flex items-center gap-2 text-base font-semibold">
            <Sparkles className="text-brand-600 size-4" aria-hidden />
            {t('reports.smart.heroTitle')}
          </h2>
          <p className="text-muted max-w-prose text-sm">{t('reports.smart.heroBody')}</p>
        </div>
        <Link
          to="/reports/smart"
          className="bg-brand-600 hover:bg-brand-700 inline-flex h-10 items-center gap-2 rounded-lg px-4 text-sm font-medium text-white"
        >
          {t('reports.smart.heroAction')}
          <ArrowRight className="size-4 rtl:-scale-x-100" aria-hidden />
        </Link>
      </div>
      {quick.length > 0 ? (
        <div className="mt-3 flex flex-wrap gap-2" aria-label={t('reports.smart.quickTitle')}>
          {quick.map((entry) => (
            <button
              key={entry.key}
              type="button"
              onClick={() => navigate('/reports/smart', { state: { prefill: entry.request } })}
              className="border-line text-ink hover:border-brand-300 rounded-full border bg-white px-3 py-1 text-sm"
            >
              {t(`reports.smart.suggestions.${entry.key}`)}
            </button>
          ))}
        </div>
      ) : null}
    </Card>
  );
}
